var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 8.33362H0.5V39.6663H47.5V8.33362Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.551 8.33362V24.5108V39.6663H0.5V8.33362H18.551Z",
    fill: "#006600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5508 29.875C21.7955 29.875 24.4258 27.2447 24.4258 24C24.4258 20.7553 21.7955 18.125 18.5508 18.125C15.3061 18.125 12.6758 20.7553 12.6758 24C12.6758 27.2447 15.3061 29.875 18.5508 29.875Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2461 21.0625V24.7345C15.2461 26.5596 16.7257 28.0392 18.5508 28.0392C20.3759 28.0392 21.8555 26.5596 21.8555 24.7345V21.0625H15.2461Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5508 25.8359C17.9434 25.8359 17.4492 25.3418 17.4492 24.7344V23.2656H19.6524V24.7344C19.6523 25.3417 19.1581 25.8359 18.5508 25.8359Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortug);
export default __webpack_public_path__ + "static/media/Portug.8fd83ff3.svg";
export { ForwardRef as ReactComponent };